module.exports = __webpack_public_path__ + "static/book-tab-app-cover-9d2f69e762f7cd5d11b0276afb2d4217.png";